import React from "react";
import dante from "../../assets/dante.png";
import logo from "../../assets/dgpu-logo.png";
import dgpuToken from "../../assets/dgpu-token.png";
import "./hero.css";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-red-overlay"></div>

      {/* Navbar */}
      <div className="navbar container">
        {/* Logo */}
        <img src={logo} alt="DanteGPU logo" className="navbar-logo-image" />

        <div className="navbar-buttons">
          <a
            href="https://t.me/+3d6uCNf5pX42YTY8"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-join-button"
          >
            Join Now
          </a>
        </div>
      </div>

      {/* Hero content */}
      <div className="hero-content container">
        <h1 className="hero-heading">
          A New Era <i>of</i> GPU & AI Agent Renting
        </h1>

        <p className="hero-text">
        DanteGPU is a platform that enables AI agents to efficiently utilize distributed GPU resources through the Solana blockchain.

        </p>
      </div>

      <div className="white-line"></div>

      <div className="hero-buttons">
        <a
          href="https://t.me/+3d6uCNf5pX42YTY8"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-button join-now"
        >
          Join Now
        </a>

        <button className="hero-button rent-gpu">Rent a GPU</button>

        <a
          href="https://gmgn.ai/sol/token/7xUV6YR3rZMfExPqZiovQSUxpnHxr2KJJqFg1bFrpump"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-button get-token"
        >
          Get <img src={dgpuToken} alt="dGPU" className="token-icon" /> Token
        </a>
      </div>

      {/* Dante image */}
      <div className="hero-dante-container">
        <img src={dante} alt="Dante character" className="hero-dante-image" />
        <div className="hero-dante-overlay"></div>
      </div>
    </section>
  );
};

export default Hero;
